module.exports = __webpack_public_path__ + "static/media/whatsapp-square-brands.bf949027.svg";